<template>
  <b-col
    :cols="colSize * 6"
    :sm="colSize * 4"
    :md="colSize * 2"
    :lg="colSize * 2"
    :xl="colSize"
    v-bind="$attrs"
  >
    <b-form-group :label="label" label-for="input" :label-cols="labelCols">
      <date-picker
        :first-day-of-week="1"
        :format="format ? format : 'DD.MM.YYYY'"
        :data-vv-as="label"
        :value="value"
        @input="$emit('input', $event)"
        @change="$emit('onChange', $event)"
        :lang="lang"
        :placeholder="placeholder || 'Выберите дату'"
        width="100%"
        :notBefore="notBefore || new Date('1800-01-01')"
        :notAfter="notAfter || new Date()"
        :type="type ? type : 'date'"
      ></date-picker>
    </b-form-group>
  </b-col>
</template>

<script>
import { EventBus } from '@/event-bus';
export default {
  name: 'filter-date-range',
  props: ['value', 'label', 'cols', 'type', 'format', 'labelCols', 'placeholder', 'notBefore', 'notAfter'],
  computed: {
    colSize: function() {
      return this.cols || 3;
    },
  },
  data() {
    return {
      lang: 'ru',
    };
  },
  created() {
      this.lang = (localStorage.lang || 'ru').toLowerCase();
      EventBus.$on('lang-changed', (lang) => {
        this.lang = lang;
      });
  }
};
</script>
